import styled from 'styled-components'

export const StakeContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  padding: 22px 24px 32px;
  margin: 0 0 14px;
  background: linear-gradient(
    157.67deg,
    rgba(72, 157, 254, 0.63) 0.4%,
    rgba(34, 7, 90, 0.42) 87.86%
  );
  backdrop-filter: blur(10px);
  @media (max-width: 768px) {
    padding: 20px 16px 21px;
    border-radius: 12px;
    margin-bottom: 8px;
  }
`
export const StakeMaturity = styled.div`
  display: flex;
  font-weight: 700;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const StakeMaturityItem = styled.div`
  width: 86%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`

export const StakeMaturityItemContainer = styled.div`
  width: max-content;
  text-align: right;
`

export const StakeMaturityItemText = styled.span`
  color: #7a97df;
`

export const StakeMaturityItemInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-right: 28px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
`
export const StakeInfo = styled.div`
  display: flex;
  justify-content: space-around;
`

export const StakeInfoItem = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  gap: 4px;
  @media (max-width: 768px) {
    font-size: 11px;
  }
`
export const StakeInfoItemText = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0.5px;
  text-align: left;
  margin: 0 0 5px;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`

export const StakeInfoItemTextSpan = styled.span`
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0.5px;
  text-align: left;

  margin-left: 5px;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`
export const CardButtonWrapper = styled.div`
  align-self: center;
`

export const StakeIconLogoMaturity = styled.span`
  position: absolute;
  right: 0;
  bottom: 14px;
`

export const StakeIconLogo = styled.span`
  position: relative;
  left: 3px;
  top: 2px;
`
export const StakeIconSkin = styled.span`
  position: relative;
  left: 0;
  top: 3px;
  margin-left: 5px;
`
